import {
  GAME_BOARD_SIZE,
  HEX_SIDE_LENGTH_DESKTOP,
  HEX_SIDE_LENGTH_MIN,
  ZOOM_STEP,
} from "./constants_v2.js";
import { board } from "./game/gameBoard_v2.js";
import { colors } from "./colors_v2.js";
import { profile } from "./profile/profile_v2.js";
import { newMatch } from "./matches/newMatch_v2.js";
import { currentMatch } from "./matches/currentMatch_v2.js";
import { join } from "./matches/join_v2.js";
import { help } from "./help_v2.js";
import { recentMatches } from "./matches/recentMatches_v2.js";
import { eventHub } from "./eventHub_v2.js";

var zoomState = {
  hexSide: HEX_SIDE_LENGTH_DESKTOP,
};

const getHexSide = () => {
  return zoomState.hexSide;
};

const setDefault = () => {
  const vw = Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0,
  );

  if (vw < 390) {
    zoomState.hexSide = 35;
    return;
  }
  if (vw >= 390 && vw < 430) {
    zoomState.hexSide = 35;
    return;
  }
  if (vw >= 430 && vw < 504) {
    zoomState.hexSide = 40;
    return;
  }
  if (vw >= 504) {
    zoomState.hexSide = 44;
    return;
  }
};

const render = () => {
  const html = `<div class="zoom" id="zoomIn">+</div><div class="zoom" id="zoomOut">-</div>`;
  document.getElementById("zoomSection").innerHTML = html;
  document.getElementById("zoomSection").style.backgroundColor =
    colors.getGameColor("background");
  const zoomIn = document.getElementById("zoomIn");
  zoomIn.style.backgroundColor = colors.getGameColor("accent");
  zoomIn.style.borderColor = colors.getGameColor("hexGrid");
  const zoomOut = document.getElementById("zoomOut");
  zoomOut.style.backgroundColor = colors.getGameColor("accent");
  zoomOut.style.borderColor = colors.getGameColor("hexGrid");
};

const handleMouseLeave = (event) => {
  event.target.style.backgroundColor = colors.getGameColor("accent");
};

const handleMouseEnter = (event) => {
  event.target.style.backgroundColor = colors.getGameColor("lightAccent");
};

/**
 * Prevents you from zooming in wider than the viewport
 */
const adjustZoom = () => {
  const min = zoomState.hexSide * 1.75 * GAME_BOARD_SIZE;
  const win = window.innerWidth;
  if (win < min) {
    zoomOut();
  }
};

const resizeCanvas = () => {
  const canvas = document.getElementById("canvas");
  const viewportWidth = window.innerWidth;
  const preferredWidth = zoomState.hexSide * (GAME_BOARD_SIZE * 1.59);
  const canvasWidth =
    viewportWidth < preferredWidth ? viewportWidth : preferredWidth;

  canvas.width = canvasWidth;

  canvas.height = zoomState.hexSide * 1.93 * GAME_BOARD_SIZE;

  if (viewportWidth < 414 && zoomState.hexSide >= HEX_SIDE_LENGTH_DESKTOP) {
    zoomOut();
  }
};

const handleZoom = (event) => {
  const element = event.target.id;
  if (element === "zoomIn") {
    zoomIn();
  }
  if (element === "zoomOut") {
    zoomOut();
  }
};

const zoomIn = () => {
  zoomState.hexSide = zoomState.hexSide + ZOOM_STEP;
  adjustZoom();
  postZoomReRender();
};

const zoomOut = () => {
  if (zoomState.hexSide - ZOOM_STEP >= HEX_SIDE_LENGTH_MIN) {
    zoomState.hexSide = zoomState.hexSide - ZOOM_STEP;
    postZoomReRender();
  }
};

const postZoomReRender = () => {
  currentMatch.setFlexDir(); //manual responsive design ;-)
  resizeCanvas();
  board.render();
  if (profile.size() === "normal") {
    profile.render("normal");
  }
  if (newMatch.getSize() === "normal") {
    newMatch.render("normal");
  }
  if (currentMatch.getSize() === "normal") {
    currentMatch.render("normal");
  }
  if (join.getSize() === "normal") {
    join.render("normal");
  }
  if (help.getSize() === "normal") {
    help.render("normal");
  }
  if (recentMatches.getSize() === "normal") {
    recentMatches.render("normal");
  }
};

eventHub.registerEvent("click", "zoomIn", handleZoom);
eventHub.registerEvent("pointerover", "zoomIn", handleMouseEnter);
eventHub.registerEvent("pointerout", "zoomIn", handleMouseLeave);

eventHub.registerEvent("click", "zoomOut", handleZoom);
eventHub.registerEvent("pointerover", "zoomOut", handleMouseEnter);
eventHub.registerEvent("pointerout", "zoomOut", handleMouseLeave);

eventHub.registerEvent("resize", window, adjustZoom);

export const zoom = {
  getHexSide,
  setDefault,
  render,
  resizeCanvas,
  zoomIn,
  zoomOut,
};
